export function setGrabbingClassOnHTMLElement(hasClass: boolean): void {
  const documentBody = document.getElementsByTagName('body').item(0) as HTMLElement;
  documentBody.classList.toggle('grabbing', hasClass);
}
